// removed by extract-text-webpack-plugin
module.exports = {"component":"_2zOiimNT1htNWk33BZ5j0h","button":"PBgrSZdr_Rd5kw4x3O4y9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/NewMsgButton/NewMsgButton.css
// module id = 1309
// module chunks = 0